import * as React from "react";
import { AppInterface, OpenDashContext } from "..";

export function useOpenDashApp(): AppInterface {
  return React.useContext(OpenDashContext);
}
